const L1PlanDate = (initiative) => {
  if (!initiative || !initiative.timeline || !Array.isArray(initiative.timeline)) {
    return null;
  }
  const l1Entry = initiative.timeline.find((entry) => entry.stage === 'L1');
  if(!new Date(l1Entry.date.actual)){
    return null;
  }
  return new Date(l1Entry.date.actual);
};

export default L1PlanDate;
